export default __webpack_public_path__ + "static/media/hiperfoco em carros.81ee8905.png";